const timeZone = "Europe/Berlin";

export function getLocalDay(date: Date) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    weekday: "long",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value || "";

  return {
    day: part("weekday").toLowerCase() as Travelguide.Weekday,
    date: `${part("year")}-${part("month")}-${part("day")}`,
  };
}

export function isOpenToday(
  {
    openingHours = [],
    specialOpeningHours = [],
  }: Pick<
    Travelguide.POISection.Information,
    "openingHours" | "specialOpeningHours"
  >,
  at?: Date
) {
  const { day, date } = getLocalDay(at || new Date());

  const exceptions = specialOpeningHours.filter(
    ({ dateFrom, dateTo }) => date >= dateFrom && date <= dateTo
  );

  for (const { isOpen, hours } of exceptions) {
    if (!isOpen) {
      return false;
    }
    if (!hours.length) {
      return true;
    }
    if (hours.some(({ days }) => !days?.length || days.includes(day))) {
      return true;
    }
  }

  return Boolean(openingHours.find((entry) => entry.day === day)?.hours.length);
}
